module.exports = __webpack_public_path__ + "static/media/Team-Hanyu.9308ff4c.jpg";